import { render, staticRenderFns } from "./TaskItem.vue?vue&type=template&id=57c10e9d&scoped=true"
import script from "./TaskItem.vue?vue&type=script&lang=js"
export * from "./TaskItem.vue?vue&type=script&lang=js"
import style0 from "./TaskItem.vue?vue&type=style&index=0&id=57c10e9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c10e9d",
  null
  
)

export default component.exports